/**
 * @description Specifies the different assignment types and provides some helper functions
 */
export const AssignmentType = {
  0: 'Available',
  1: 'UserAssigned',
  2: 'DefaultAssigned',
  3: 'Blocked',
  4: 'Forceable',
  'Available': 0,
  'UserAssigned': 1,
  'DefaultAssigned': 2,
  'Blocked': 3,
  'Forceable': 4,

  /**
   * @description Creates a key based on the assignment types 
   * @param {object[]} arrayWithStates An array which contains items with assignment types
   * @returns {number} A unique hash key
   */
  createHashKey( arrayWithStates ) {
    return arrayWithStates.reduce( ( current, item ) => {
      if ( !item ) {
        return current ^= -1;
      }
      if ( this.isAvailable( item ) || this.isSelected( item ) ) {
        return current ^= item.name.length;
      }
      return current;
    }, 0 );
  },
  /**
   * @description Checks if the assignment can be selected
   * @param {object} item An item with an assignment type
   * @returns {boolean} True, if the item can be selected
   */
  isAvailable( item ) {
    return item.state >= 0 && item.state <= 2;
  },
  /**
   * @description Checks if the assignment is selected
   * @param {object} item An item with an assignment type
   * @returns {boolean} True, if the item is selected
   */
  isSelected( item ) {
    return item.state === 1 || item.state === 2;
  }
};